import { computed, ref, watch, getCurrentInstance,nextTick } from "@vue/composition-api";
import { useChatbot } from "@/composables/chatbot";
import { useChatbotFake } from "@/composables/chatbotFake";
import store from "@/store";
import { useToast } from "vue-toastification/composition";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@/libs/axios";
import { debounce } from "lodash";
import { useTranslates } from "@/utils/useTranslates";
import formValidation from "@core/comp-functions/forms/form-validation";

export function useFinance(isEdit, emit, fetchList) {
  const { refFormObserver, getValidationState } = formValidation();
  const toast = useToast();
  const { t } = useI18nUtils();

  const translates = {
    "billing_finance.save_successfully": t("billing_finance.save_successfully"),
  };

  const monthOptions = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre'
  ];

  const serviceDaysOptions = [
    '0',
    '1',
    '5',
    '6',
    '7'
  ];

  const typeOfGuardOptions = [
    "Fija",
    "Variable"
  ];

  const workScheduleOptions = [
    "Lu-Vi",
    "Lu-Sa",
    "Lu-Do",
    "Ma-Do",
    "Sa-Do",
    "Por hora",
  ];

  const finance = ref({
    month: "",
    year: "",
    region: "",
    state: "",
    rems: "",
    security_company: "",
    job_description: "",
    number_of_services: "",
    service_days: "",
    hours: "",
    cost_per_shift: "",
    type_of_guard: "",
    work_schedule: "",
    id_unit: "",
  })

  const loading = ref(false);
  

  const loadEditData = (item) => {
    if(!isEdit) return;
    finance.value = {...item, service_days: String(item.service_days)}
  };

  const onClose = () => {
    emit("close");
  };

  const onSubmit = async () => {
    try {
      const isValid = await refFormObserver.value.validate();
      if (!isValid) return;
      const payload = (({ id, created_at, updated_at, ...rest }) => rest)(finance.value);
      let url = `v1/billing-finances`;
      let method = 'post';
      
      if (isEdit) {
        url = `v1/billing-finances/${finance.value.id}`;
        method = 'put';
      }
      
      const { data } = await axios[method](url, payload);
      contentToast(translates["billing_finance.save_successfully"], "success");
      onClose();

      fetchList();
    } catch (error) {
      const { message = 'error' } = error.response.data;
      contentToast(message, "danger");
    }
  };

  function contentToast(message, type) {
    toast({
      component: ToastificationContent,
      props: {
        title: message,
        icon: "CheckIcon",
        variant: type,
      },
    });
  }

  return {
    finance,
    monthOptions,
    serviceDaysOptions,
    typeOfGuardOptions,
    workScheduleOptions,
    loading,
    refFormObserver,
    getValidationState,
    loadEditData,
    onClose,
    onSubmit
  }
}
